import { Component, Inject, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CaptionService } from '../../../../utils/shared-services/caption.service';
import { BrowserStorage } from '../../../../utils/shared-services/browser-storage.service';
import { WidgetDescriptionDialog } from '../../../../features/store-portal/components/dialogs/widget-description-dialog.component';

@Component({
    selector: 'hoWid021',
    templateUrl: 'src/app/features/store-portal/widgets/templates/wid-021.html',
    standalone: false
})
export class HoWid021 {
    public captions: any;
    public isTimedOut: boolean = false;
    public areDatapointsInvalid: boolean = true;
    public invalidDatapoints: any[] = [];
    public datapoints: any[] = [];

    public headers: string[];
    public labels: string[];
    public datasets: any[];

    constructor(
        @Inject(Object) @Optional() private widget: any,
        @Inject(CaptionService) private captionService,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(BrowserStorage) private browserStorage: BrowserStorage
    ) {
        this.captions = this.captionService.captions;
        this.headers = [this.captions.payMethodFront, this.captions.count];
        if (this.widget?.id) {
            this.datapoints = this.browserStorage.getSessionstorage(this.widget.id, null);
        }
    }

    openInfoDialog() {
        this.dialog.open(WidgetDescriptionDialog, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '95vw',
            data: {
                widgetID: 'ho-' + this.widget.id,
            },
        });
    }

    ngOnInit() {
        // to change animation on wid-000
        if (this.widget && this.widget.isTimedOut) {
            this.isTimedOut = true;
            return;
        }

        if (!this.widget || !this.widget.isLoaded) {
            return;
        }

        // Verify datapoints, making sure they are not null or undefined
        this.areDatapointsInvalid = false;
        for (let i = 0; i < this.widget.data.length; i++) {
            if (!this.widget.data[i]) {
                this.areDatapointsInvalid = true;
                this.invalidDatapoints.push(this.datapoints[i]);
            }
        }

        let paymentData = this.widget.data[0].Record;
        if (!paymentData) {
            this.labels = [];
            this.datasets = [];
            return;
        }

        let labels = [],
            dataset = [];
        paymentData = Array.isArray(paymentData) ? paymentData : [paymentData];
        paymentData.forEach((item) => {
            if (item.METHODDESC_GROUP === '[OTHER]') {
                item.METHODDESC_GROUP = this.captions.other;
            }
            labels.push(item.METHODDESC_GROUP);
            dataset.push(item.TOTAL_POSSALES_COUNT);
        });
        this.labels = labels;
        this.datasets = [{ data: dataset }];
    }    
}